// extracted by mini-css-extract-plugin
module.exports = {"storyHeading":"DetailSection_storyHeading__3pJ3e","storyDetail":"DetailSection_storyDetail__aOMbm"};